"use client";

import dynamic from "next/dynamic";

import type { ResolvedFlowTemplate } from "@/app/_api/flowTemplatesServer";

// Lazy-load the interactive grid + modal run panel so it ships as its own async
// chunk instead of being folded into the shared block-renderer chunk every CMS
// page first-loads. `dynamic()` only defers a client tree when called from a
// Client Component — doing it in the Server renderer is a no-op, so the tree
// leaks into that shared chunk. Mirrors `BlockFlowsDemoWrapper`.
const BlockFlowTemplateGallery = dynamic(() =>
  import("./BlockFlowTemplateGallery").then(mod => mod.BlockFlowTemplateGallery),
);

export function BlockFlowTemplateGalleryWrapper({ items }: { items: ResolvedFlowTemplate[] }) {
  return <BlockFlowTemplateGallery items={items} />;
}
